import { useQuery } from "@apollo/client";
import { getStatuses } from "api/queries/RCA/StatusAPI";
import { IStatus, IStatusEntity } from "./StatusEntityInterfaces";
import { useEffect, useState } from "react";

export const StatusEntity: IStatusEntity = {
    GetStatuses: () => {
        const { loading, error, data } = useQuery(getStatuses);
        const [statuses, setStatuses] = useState<IStatus[]>([]);

        useEffect(() => {
            if (data) {
                setStatuses(data.status);
            }
        }, [data]);

        return {
            loading,
            statuses,
            apolloQueryError: error,
        };
    },
};
